import {
  beforeAuthStateChanged,
  onAuthStateChanged,
  ParsedToken,
  User,
} from "firebase/auth";
import { makeAutoObservable, observable, runInAction } from "mobx";
import UserDataStore from "./UserDataStore";
import { auth } from "../api/firebase";
import DeviceStore from "./DeviceStore";

class SessionStore {
  user: User | null = null;
  claims: ParsedToken = {};

  constructor() {
    makeAutoObservable(this, {
      user: observable,
    });
    beforeAuthStateChanged(auth, async (userAuth) => {
      if (!userAuth) return;
      const tokenResult = await userAuth.getIdTokenResult();
      const hasAdminPermission = !!tokenResult.claims.admin;
      if (!hasAdminPermission)
        throw Error("User is not authorized to use the app");
    });
    onAuthStateChanged(auth, (userAuth) => {
      if (userAuth) {
        UserDataStore.getCurrentUser(userAuth.uid);
      } else {
        UserDataStore.resetStore();
        DeviceStore.resetStore();
      }
      runInAction(async () => {
        this.user = userAuth;
      });
    });
  }
}

export default new SessionStore();
